export const convertFontWeight = (weight: string) => {
  switch (weight) {
    case 'Regular':
      return '400';
    case 'Medium':
      return '500';
    case 'Semibold':
      return '600';
    default:
      return weight;
  }
};
